import Vue from "vue";
import { default as Vuex } from "vuex";
import { authModule } from "./modules/auth";
import createLogger from "./logger";
import { GlobalState } from "./global";
import { Studio } from "@/api/Studio";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const store = new Vuex.Store<GlobalState>({
  state: {
    appBlocked: false,
    appLoading: true,
    studios: [],
    gewaehltesDatum: null,
    gewaehltesStudio: null,
  },

  mutations: {
    blockApp(state, blocked: boolean) {
      state.appBlocked = blocked;
    },
    appLoading(state, loading: boolean) {
      state.appLoading = loading;
    },
    datumGewaehlt(state, datum: string) {
      state.gewaehltesDatum = datum;
    },
    studioGewaehlt(state, studio: Studio) {
      state.gewaehltesStudio = studio;
    },
    studiosGeladen(state, studios: Studio[]) {
      state.studios = studios;
    },
  },

  actions: {
    appLoading(context, loading) {
      context.commit("appLoading", loading);
    },
    selectDatum(context, param: { datum: string }) {
      context.commit("datumGewaehlt", param.datum);
    },
    selectStudio(context, param: { studio: Studio }) {
      context.commit("studioGewaehlt", param.studio);
    },
    studiosGeladen(context, param: { studios: Studio[] }) {
      context.commit("studiosGeladen", param.studios);
    },
  },

  getters: {
    isAppLoading: (state, getters, rootState, rootGetters) => state.appLoading,
    isAppBlocked: (state, getters, rootState, rootGetters) => state.appBlocked,
    studios: (state, getters, rootState, rootGetters) => state.studios,
    gewaehltesDatum: (state, getters, rootState, rootGetters) =>
      state.gewaehltesDatum,
    gewaehltesStudio: (state, getters, rootState, rootGetters) =>
      state.gewaehltesStudio,
  },

  modules: {
    auth: authModule,
  },

  plugins: debug ? [createLogger()] : [],
});

export { store };
